import React from "react";
import { useSelector } from "react-redux";
import { getCurrentUserInvitation } from "../../store/invitations";
import { getUserById } from "../../store/users";
import { useI18n } from "../../i18n/LanguageContext";

const Invitation = (props) => {
  const invitation = useSelector(getCurrentUserInvitation());
  const invitedUser = useSelector(getUserById(invitation && invitation.from));
  const { t } = useI18n();

  return (
    <>
      {invitation !== null ? (
        <div>
          <div>
            {t("add.from")}
            <span className="font-bold">
              {invitedUser ? " " + invitedUser.nickname : ""}
            </span>
          </div>
        </div>
      ) : (
        <div>{t("invite.none")}</div>
      )}
    </>
  );
};

export default Invitation;
